export const ENABLE_COOKIE_FLAGS_COOKIE = 'mnpg_enable-cookie-flags'
export const FLAG_COOKIE_PREFIX = 'mnpg_flag_'
